import { use } from "react";
import { ToastContext } from "./ToastContext";

export function useToast() {
  return use(ToastContext);
}
